export const emailDomains = [
	"gmail.com",
	"hotmail.com",
	"yahoo.com",
	"outlook.com",
	"yahoo.com.br",
	"uol.com.br",
	"ig.com.br",
	"terra.com.br",
	"aol.com",
	"live.com",
	"msn.com",
];
